import styled from '@emotion/styled'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const AddIcon = styled(FontAwesomeIcon)`
  margin-right: 15px;
`
